// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"ts_a","ReactCrop--disabled":"ts_b","ReactCrop--circular-crop":"ts_c"};